import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'ras-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {

	public now: Date = new Date()
	public busy: boolean = false
	public email: string = ""
	public error_message = null

	@Input() thin: boolean = false

	// MailChimp configuration from environment
	public readonly mailchimpUrl = environment.mailchimpUrl || 'https://rentastore.us13.list-manage.com/subscribe/post';
	public readonly mailchimpUserId = environment.mailchimpUserId || 'a696f656183195751e2c27e61';
	public readonly mailchimpListId = environment.mailchimpListId || 'eed9c4afed';
	public readonly mailchimpHiddenField = environment.mailchimpHiddenField || 'b_a696f656183195751e2c27e61_7a1161037d';

	constructor() { }

	ngOnInit(): void {
	}

	/**
	 * Get the complete MailChimp form action URL with parameters
	 */
	get mailchimpFormAction(): string {
		return `${this.mailchimpUrl}?u=${this.mailchimpUserId}&id=${this.mailchimpListId}`;
	}

	subscribe() {
		this.busy = true
		this.error_message = "Sorry, we couldn't subscribe you to our newsletter at this time. Please try again later."
		this.busy = false
	}
}